<template>
  <div v-show="tablePagination && tablePagination.last_page > 1" :class="[`${baseClass}-wrapper`]">
    <div :class="[baseClass]">
      <!-- First Page -->
      <a @click="loadPage(1)" :class="[baseItemClass, isOnFirstPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-left" icon="ks-icon-double-chevron" />
      </a>

      <!-- Previous Page -->
      <a @click="loadPage('prev')" :class="[baseItemClass, isOnFirstPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-left" icon="ks-icon-chevron" />
      </a>

      <template v-if="notEnoughPages">
        <template v-for="n in totalPage">
          <a @click="loadPage(n)" :key="n" v-html="n" :class="[baseItemClass, isCurrentPage(n) ? activeItemClass : '']" />
        </template>
      </template>

      <!-- Page Numbers -->
      <template v-else>
        <template v-for="n in windowSize">
          <a @click="loadPage(windowStart + n - 1)" :key="n" v-html="windowStart + n - 1"
            :class="[baseItemClass, isCurrentPage(windowStart + n - 1) ? activeItemClass : '']"></a>
        </template>
      </template>

      <!-- Next Page -->
      <a @click="loadPage('next')" :class="[baseItemClass, isOnLastPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-right" icon="ks-icon-chevron" />
      </a>

      <!-- Last Page -->
      <a @click="loadPage(totalPage)" :class="[baseItemClass, isOnLastPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-right" icon="ks-icon-double-chevron" />
      </a>

      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
  import 'Components/icons'
  import PaginationMixin from 'Components/vuetable-2/VuetablePaginationMixin.vue'
  import svgicon from 'vue-svgicon'

  export default {
    components: { svgicon },
    mixins: [PaginationMixin],
    data () {
      const baseClass = 'pagination'
      const baseItemClass = `${baseClass}__item`
      const activeItemClass = `${baseItemClass}--active`
      const disabledItemClass = `${baseItemClass}--disabled`

      return {
        baseClass,
        baseItemClass,
        activeItemClass,
        disabledItemClass,
      }
    },
  }
</script>

<style lang="scss">
  @use "~Styles/variables";

  @media screen and (max-width: 768px) {
    .pagination-wrapper {
      margin-bottom: variables.$task-list-header-height;
    }
  }
</style>
